__webpack_require__.p = "/apps/scoreboards-renderer/static/";